import { Stack } from 'braid-design-system';
import { shallowEqual, useSelector } from 'react-redux';

import { useShoppingCart } from 'src/app/shared/hooks/useShoppingCart';
import { getProductFeatureByType } from 'src/app/utils/getProductFeatureByType';
import PageLayout from 'src/app/v1/views/layouts/PageLayout';
import { FaqSection } from 'src/app/v1/views/sections/FaqSection';
import type { AppState } from 'src/types/appState';

import { ExtraTaskSteps } from '../ExtraTaskSteps';
import { SuccessHeader } from '../SuccessHeader';
import { UpsellPanel } from '../UpsellPanel';

interface Props {
  jobId?: string;
}
export const SuccessBodyContent = ({ jobId }: Props) => {
  const productFeatures = useSelector(
    (state: AppState) => state.session.productFeatures,
    shallowEqual,
  );
  const { cartFeatures } = useShoppingCart();
  const doNewFeaturesHavePerUnitBilling = Boolean(
    getProductFeatureByType({
      featureType: 'PerUnitBilling',
      productFeatures: cartFeatures,
    }),
  );
  const doExistingFeaturesHavePerUnitBilling = Boolean(
    getProductFeatureByType({
      featureType: 'PerUnitBilling',
      productFeatures,
    }),
  );
  const isPerUnitBilling =
    doNewFeaturesHavePerUnitBilling || doExistingFeaturesHavePerUnitBilling;
  return (
    <PageLayout headerContent={<SuccessHeader />}>
      <Stack space="xlarge">
        <ExtraTaskSteps jobId={jobId} />
        {!isPerUnitBilling && <UpsellPanel />}
        <FaqSection />
      </Stack>
    </PageLayout>
  );
};
